import { useAuth } from "../context/auth-context";
import { useNavigate } from "react-router-dom";
import firebase from "../util/firebase";
import React, { useEffect, useState } from "react";
import Modal from "../components/Modal";

export default function Title({ title, settingsButton }) {
  const { currentUser, logout } = useAuth();
  const history = useNavigate();
  const [showModal, setShowModal] = useState(false);

  function handleLogout() {
    try {
      logout();
      history("/login");
    } catch {
      alert("Error logging out");
    }
  }

  function saveUserSettings() {
    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .set(currentUser.settings);

    setTimeout(() => {
      setShowModal(true);
    }, 700);
    setTimeout(() => {
      setShowModal(false);
    }, 4700);
  }

  return (
    <div className="flex items-center justify-between my-4 mx-4 p-2">
      <Modal showModal={showModal} setShowModal={setShowModal} />
      <div className="flex-2 min-w-0">
        <h2 className="font-bold leading-7 sm:text-4xl text-blue-primary ml-24 p-1">
          {title}
        </h2>
      </div>
      <div className="mt-4 flex md:mt-0 md:ml-4">
        {settingsButton && !currentUser.admin && (
          <button
            onClick={saveUserSettings}
            type="button"
            className="mr-4 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-md font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-complimentary"
          >
            Save My Settings
          </button>
        )}
        <button
          onClick={handleLogout}
          type="button"
          className="inline-flex items-center px-4 py-2 border border-gray-100 rounded-md shadow-sm text-md font-medium text-white bg-blue-primary hover:bg-blue-complimentary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-complimentary"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
